import {ReactNode, Component} from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';

import AppWrapper from './AppWrapper';
import PrivateRoute from './PrivateRoute';
import Login from '../Authentication/Login';
import Logout from '../Authentication/Logout';

class AppRouter extends Component {
	public render(): ReactNode {
		return (
			<BrowserRouter>
				<Switch>
					<Route path='/login' component={Login} />
					<PrivateRoute
						mustBeAdmin={false}
						path='/logout'
						component={Logout}
					/>
					<PrivateRoute
						mustBeAdmin={false}
						path=''
						component={AppWrapper}
					/>
				</Switch>
			</BrowserRouter>
		);
	}
}

export default AppRouter;
